import { MerchantNotificationsEventNamesType } from 'config/requests/merchants';
import {
  PROVIDERS_AVAILABLE_NOTIFICATIONS_TYPES,
  ProvidersAvailableNotificationsTypesNames,
} from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/constants/providersAvailableNotificationsTypes';
import { BooleanInput } from 'shared/react-admin/Inputs';

type Props = MerchantNotificationsEventNamesType & {
  key?: string;
  hasProvider: boolean;
};
export const MerchantsShowNotificationsEvent: React.FC<Props> = ({
  description,
  name,
  hasProvider,
  value,
}) => {
  const disabled =
    hasProvider &&
    !PROVIDERS_AVAILABLE_NOTIFICATIONS_TYPES.includes(
      value as ProvidersAvailableNotificationsTypesNames,
    );

  return (
    <BooleanInput
      defaultValue={false}
      disabled={disabled}
      label={description}
      size="small"
      source={`event.${name}`}
    />
  );
};
